export const isStringEmpty = (val?: string | null): boolean => val == null || val === ''
export const isStringNotEmpty = (val?: string | null): boolean => !isStringEmpty(val)
